import { useReducer } from 'react';
import { LOAD_END_ACTION_HOOK, LOAD_START_ACTION_HOOK } from '../constants';

const initialState = {
  loading: false,
  data: [],
};

const reducer = (state, action) => {
  switch (action.type) {
    case LOAD_START_ACTION_HOOK:
      return { ...state, loading: true };
    case LOAD_END_ACTION_HOOK:
      return { ...state, loading: false, data: action.data };
    default:
      return state;
  }
};

export default function useDataLoadingState() {
  return useReducer(reducer, initialState);
}
